export function BulletList({ items }: { items: string[] }) {
  return (
    <ul className="list-disc">
      {items.map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ul>
  );
}
